import React, { useEffect, useRef, useState } from "react";
import "./auth.css";
import auth_logo from "../../assets/auth_logo.png";
import login_rgt_img from "../../assets/Group 1261157977.png";
import OTPInput from "react-otp-input";
import { FiEdit3 } from "react-icons/fi";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { sendOtpApi, verifyOtpApi } from "../../services/auth";
import { LoadingButton } from "../../Components/header/form";
import useResendOtp from "../../hooks/useResendOtp";
import { toastMessage } from "../../utils/toastMessage";
import { decryptData, encryptData } from "../../utils/dataCipher";
import { setToken } from "../../config/AxiosInstance";
import { GoArrowRight } from "react-icons/go";
import Slider from "react-slick";
import {
  SampleNextArrow,
  SamplePrevArrow,
} from "../../Components/slider/Arrow";
import { socket } from "../../utils/socket";
import { logicalicon_blue } from "../../assets";

const Otp = () => {
  const resendTextRef = useRef(null);
  const [searchParam, setSearchParam] = useSearchParams();

  let phone = searchParam.get("info") || {};
  let encryptedData;
  // Get the query string (encrypted data)
  if (Object.keys(phone).length) {
    encryptedData = decryptData(phone);
  }

  const { canResend, resetTimer } = useResendOtp(resendTextRef);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  // Resend Otp Handler
  const resendOtpHandler = async () => {
    try {
      setLoading(true);
      const { data } = await sendOtpApi({
        dialCode: `${encryptedData?.dialCode}`,
        number: encryptedData?.number,
      });
      const isSuccess = data?.success;
      toastMessage(data?.message, isSuccess ? "success" : "error", "sendOtp");
      resetTimer();
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (resendOtp = false) => {
    try {
      setLoading(true);
      const { data } = await verifyOtpApi({
        dialCode: `${encryptedData?.dialCode}`,
        number: encryptedData?.number,
        otp: otp,
      });
      const { success, data: response, message } = data;
      const isSuccess = success;
      if (isSuccess) {
        if (response?.registered) {
          localStorage.removeItem("authInfo"); // Removing Phone Number From Local Storage
          setToken(response?.token);
          navigate("/dashboard/message/group");
          socket.auth = {
            token: response?.token
          }
          socket.connect();
        } else {
          navigate(`/registration?info=${encryptData(encryptedData)}`);
        }
      }
      toastMessage(message, isSuccess ? "success" : "error", "sendOtp");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   resendOtpHandler();
  // }, []);

  var settings = {
    dots: true,
    infinite: true,
    arrow: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow to="next" />,
    prevArrow: <SamplePrevArrow to="prev" />,
  };

  return (
    <>
      <div className="auth otp">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-12">
              <div className="login_logo">
                <Link to="/">
                  <img src={logicalicon_blue} />
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 login_wrap">
              <div className="login_content_lft">
                <h2>Enter OTP</h2>
                <p>
                  We have sent a code to
                  <b className="phne_no">{`${encryptedData?.dialCode}${" "}
                      ${encryptedData?.number}
                    `}</b>
                  &nbsp;&nbsp;
                  <FiEdit3
                    className="edit_icon"
                    onClick={() =>
                      navigate(`/login?info=${encryptData(encryptedData)}`)
                    }
                  />
                </p>

                <div className="login_mbl_no">
                  <h5>Enter you mobile number</h5>
                  <div className="custom_otp">
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={4}
                      inputStyle={"input"}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>
                </div>

                {/* Next Btn */}

                <LoadingButton
                  loading={loading}
                  isDisabled={otp.length < 4}
                  // onClick={() => navigate("/createprofile")}
                  onClick={handleVerifyOtp}
                  className={`button next-button ${otp.length < 4 ? "cstm_disabled_btn" : ""
                    }`}
                >
                  Verify OTP
                </LoadingButton>
                {/* <div className="resend_otp"> */}
                {/* <b>Resend OTP in 00:30 Seconds</b> */}

                <div
                  ref={resendTextRef}
                  className="resend_otp"
                  onClick={() => (canResend ? resendOtpHandler() : "")}
                >
                  You can resend OTP in <span>(30 second)</span>
                  {/* </div> */}
                </div>
              </div>
            </div>

            <div className="col-md-6 slider_content">
              <Slider {...settings}>
                <div className="login_img_rgt">
                  <img src={login_rgt_img} />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>

                <div className="login_img_rgt">
                  <img src={login_rgt_img} />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>

                <div className="login_img_rgt">
                  <img src={login_rgt_img} />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>
              </Slider>

              {/* <div className="login_img_rgt">
                  <img src={login_rgt_img} />
                </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
